import { useEffect, useState } from "react";
import api from "../api";
import { parseApartmentUnits } from "./rentalPortal";

export function useVacantApartments() {
  const [state, setState] = useState({ units: [], loading: true, error: "" });
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setState((prev) => ({ ...prev, loading: true, error: "" }));
    api.get("/public/vacant-properties", { signal: controller.signal, timeout: 15000 })
      .then(({ data }) => {
        if (!controller.signal.aborted) setState({ units: parseApartmentUnits(data), loading: false, error: "" });
      })
      .catch(() => {
        if (!controller.signal.aborted) setState({ units: [], loading: false, error: "We couldn’t load the apartments. Please try again." });
      });
    return () => controller.abort();
  }, [attempt]);
  return { ...state, retry: () => setAttempt((value) => value + 1) };
}

export function filterApartments(units, filters) {
  const location = (filters.location || "").trim().toLowerCase();
  const max = filters.maxRent === "" ? null : Number(filters.maxRent);
  const result = units.filter((unit) =>
    (!location || unit.location.toLowerCase().includes(location)) &&
    (max === null || !Number.isFinite(max) || unit.monthly_rent <= max) &&
    (!filters.bedrooms || (unit.details.bedrooms != null && Number(unit.details.bedrooms) === Number(filters.bedrooms)))
  );
  if (filters.sort === "price-high") result.sort((a, b) => b.monthly_rent - a.monthly_rent);
  else result.sort((a, b) => a.monthly_rent - b.monthly_rent);
  return result;
}

export const emptyFilters = { location: "", maxRent: "", bedrooms: "", sort: "price-low" };
export const readFilters = (params) => Object.fromEntries(Object.keys(emptyFilters).map((key) => [key, params.get(key) ?? emptyFilters[key]]));
export function filtersQuery(filters) {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => { if (value && value !== emptyFilters[key]) params.set(key, value); });
  return params.toString();
}
export function requestError(error) {
  const errors = error.response?.data?.errors;
  if (errors) return Object.values(errors).flat().join(" ");
  if (error.response?.status === 429) return "Too many requests. Please wait a minute before trying again.";
  return "Your request could not be sent. Your details are still here; please try again.";
}
export const philippinesToday = () => new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Manila", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());

export function listingFacts(unit) {
  const d = unit.details;
  return [d.bedrooms != null ? (Number(d.bedrooms) === 0 ? "Studio" : `${d.bedrooms} bedroom${Number(d.bedrooms) === 1 ? "" : "s"}`) : null,
    d.bathrooms != null ? `${d.bathrooms} bath${Number(d.bathrooms) === 1 ? "" : "s"}` : null,
    d.floor_area != null ? `${d.floor_area} m²` : null, d.furnishing].filter(Boolean);
}
